import { loanInfoCardsWrapperBaseStyles } from '@sharedCR/loanSummary/LoanInfoCards';

export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
};

export const getOverviewWrapperStyles = length => ({
  ...loanInfoCardsWrapperBaseStyles,
  gridTemplateColumns: {
    xs: '1fr',
    md: `repeat(${length}, 1fr)`,
  },
});

export const documentsGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '16px',
};

export const documentsColumnStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  paddingTop: '8px',
  paddingBottom: '8px',
  paddingLeft: '12px',
  paddingRight: '12px',
  border: ({ palette }) => `1px solid ${palette.divider}`,
  borderRadius: '8px',
};

export const documentsLabelStyles = {
  whiteSpace: 'nowrap',
};

export const documentLinkStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  textDecoration: 'none',
  color: 'primary.main',
  '&:hover': {
    textDecoration: 'underline',
  },
};

export const allDocumentsListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};
